module.exports = __webpack_public_path__ + "img/GalesALL.c458e236.jpg";